import React, { useEffect, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Router, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./components/Main.css";
import Navbar from "./components/Navbar/Navbar";
import Calltoaction from "./components/Calltoaction/Calltoaction";
import Client from "./components/ClientSec/Client";
import Footer from "./components/Footer/Footer";
import { FourSquare } from "react-loading-indicators";
import { AnimatePresence } from "framer-motion";
import Navigate from "./components/Navigate/Navigate";
import Callto from "./components/Callto/Callto";
import Form from "./components/Form/Form";
import Map from "./page/ContactUS/Map/Map";
import PrivacyDeletation from "./components/FooterlinkPage/Privacy/PrivacyDeletation/PrivacyDeletation";
// import { ToastContainer } from "react-toastify";

// Lazy load pages/components
const Home = React.lazy(() => import("./components/Home"));
const CaseStudy = React.lazy(() => import("./page/CaseStudy/CaseStudy"));
const Casemap = React.lazy(() => import("./page/CaseStudy/Casemap/Casemap"));
const OurserviceHome = React.lazy(() =>
  import("./page/Ourservice/OurserviceHome")
);
const CommenHome = React.lazy(() =>
  import("./components/Feautured/Commondiv/CommenHome")
);
const Contacthome = React.lazy(() => import("./page/ContactUS/Contacthome"));
const Careerhome = React.lazy(() => import("./page/Careers/Careerhome"));
const WhyWork = React.lazy(() => import("./page/Careers/WhyWork"));
const Abouthome = React.lazy(() => import("./page/About/Abouthome"));
const Soicialvaluehome = React.lazy(() =>
  import("./page/About/Soicialvalue/Soicialvaluehome")
);
const CookiesHome = React.lazy(() =>
  import("./components/FooterlinkPage/cookiesHome/cookiesHome")
);
const TermsHome = React.lazy(() =>
  import("./components/FooterlinkPage/Terms/TermsHome")
);
const ModernHome = React.lazy(() =>
  import("./components/FooterlinkPage/Modern-Slavery/ModernHome")
);
const GenderpayHome = React.lazy(() =>
  import("./components/FooterlinkPage/Genderpay/GenderpayHome")
);
const Duty2021Home = React.lazy(() =>
  import("./components/FooterlinkPage/Duty2021/Duty2021Home")
);
const Duty2022Home = React.lazy(() =>
  import("./components/FooterlinkPage/Duty2022/Duty2022Home")
);
const Duty2023Home = React.lazy(() =>
  import("./components/FooterlinkPage/Duty2023/Duty2023Home")
);
const PrivacyHome = React.lazy(() =>
  import("./components/FooterlinkPage/Privacy/PrivacyHome")
);

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]); // Re-run on location change (route change)
  return null;
}




function App() {

  const location = useLocation();
  return (
    // <Router>
      <AnimatePresence initial={false}>
        
        <Navbar />

        <ScrollToTop />
        {/* <ToastContainer /> */}
        <Suspense
          fallback={
            <div className="loading">
             <FourSquare color="#3fa6bd" size="medium" text="JR CARE LTD" textColor="#3fa6bd" />
            </div>
          }
        >
          <Routes location={location} key={location.pathname} >
            <Route index element={<Home />} />
            <Route path="/casestudy" element={<CaseStudy />} />
            <Route path="/casesmap/:id" element={<Casemap />} />
            {/* <Route path="/service" element={<OurserviceHome />} /> */}
            <Route path="/service/:id" element={<CommenHome />} />
            <Route path="/contact" element={<Contacthome />} />
            <Route path="/career" element={<Careerhome />} />
            {/* <Route path="/whywork" element={<WhyWork />} /> */}
            <Route path="/Aboutz" element={<Abouthome />} />
            <Route path="/Socialvalue" element={<Soicialvaluehome />} />
            <Route path="/cookies" element={<CookiesHome />} />
            <Route path="/term" element={<TermsHome />} />
            <Route path="/ModernSlavery" element={<ModernHome />} />
            <Route path="/genderpay" element={<GenderpayHome />} />
            <Route path="/duty2021" element={<Duty2021Home />} />
            <Route path="/duty2022" element={<Duty2022Home />} />
            <Route path="/duty2023" element={<Duty2023Home />} />
            <Route path="/privacy" element={<PrivacyHome />} />
            <Route path="/form" element={<Form/>} /> 
            <Route path="/map" element={<Map/>} /> 
            <Route path="/accountdeletion" element={<PrivacyDeletation/>} /> 
            
          </Routes>
        </Suspense>
        
        {/* <Calltoaction /> */}
            {/* <Client /> */}
            <br/>
            <br/>

        <Callto/>
        <Footer />
      </AnimatePresence>
    // </Router>
  );
}

export default App;
